import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { SITE_HOST} from '../../../../consts';
import RecipeIngredient from './RecipeIngredient';
import RecipeRatings from './RecipeRatings';
import { isValid, isText, decodeTags, segmentTrackEvent, getFileName } from '../../../../utils';
import './recipe-styles.scss';

class RecipeBasic extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
	    	checkedArray: [],
	    	selectedDirection: null,
	    };
	   	this.makeArray = this.makeArray.bind(this);
	   	this.toggleCheck = this.toggleCheck.bind(this);
	   	this.setChicoryRecipe = this.setChicoryRecipe.bind(this);
	}

	componentDidMount() {
		this.setChicoryRecipe();
        let array = this.makeArray(this.props.data.ingredients);
        const initializeCheckedArray = array.map((ingredient, i) => false);
        this.setState({ checkedArray: initializeCheckedArray});
	}

	componentWillUnmount() {
		if (this.chicoryRetryTimeout) {
			clearTimeout(this.chicoryRetryTimeout);
		}
	}

	setChicoryRecipe(attempt = 0) {
		if (typeof window === 'undefined') {
			return;
		}

		if (window.chicory && typeof window.chicory === 'function') {
			const recipeUrl = `${SITE_HOST}/recipes/${this.props.seo.webUrl}`;
			window.chicory('setRecipe', recipeUrl);
			return;
		}

		if (attempt < 20) {
			this.chicoryRetryTimeout = setTimeout(() => this.setChicoryRecipe(attempt + 1), 250);
		}
	}

	makeArray(data) {
		const { isAffiliate } = this.props;
		const freeformBtnTag = '<div class=\"wp-block-button\">';
		const freeformBtnLinkTag = 'wp-block-button__link';
		let encodedData = decodeTags(data);

		// Remove those empty FF divs with className 'wp-block-buttons' (they're empty!)
		const emptyFFDivTag = '<div class=\"wp-block-buttons\"></div>';
		const hasEmptyFFDiv = (isText(encodedData) && encodedData.includes(emptyFFDivTag));
		if (isText(encodedData) && hasEmptyFFDiv) {
			const emptyFFDivRegEx = new RegExp(emptyFFDivTag, 'g');
			encodedData = encodedData.replace(emptyFFDivRegEx, '');
		}

		let dataArray = (isText(encodedData) && encodedData) ? encodedData.split('</p>') : [];
		for (let i = 0; i < dataArray.length; i++) {
			if (!dataArray[i]) {
				break;
			};
			if (dataArray[i].includes("<p")) {
				dataArray[i]+='</p>';
			}
			if (dataArray[i].includes(freeformBtnTag) && !isAffiliate) {
				let ogTag = new RegExp(freeformBtnTag, 'g');
				let newClassTag = freeformBtnTag.replace("wp-block-button", "wp-block-button standard");
				dataArray[i] = dataArray[i].replace(ogTag, newClassTag);
				dataArray[i]+='</div>';
			}
			if (dataArray[i].includes(freeformBtnTag) && isAffiliate) {
				let ogTag = new RegExp(freeformBtnTag, 'g');
				let newClassTag = freeformBtnTag.replace("wp-block-button", "affiliate-btn");
				dataArray[i] = dataArray[i].replace(ogTag, newClassTag);
				dataArray[i]+='</div>';
			}
			if (dataArray[i].includes(freeformBtnLinkTag) && isAffiliate) {
				let ogTag = new RegExp(freeformBtnLinkTag, 'g');
				let newClassTag = freeformBtnLinkTag.replace("wp-block-button__link", "affiliate-btn__link");
				dataArray[i] = dataArray[i].replace(ogTag, newClassTag);
				dataArray[i]+='</a>';
			}
    }
    return dataArray;
	}

	transformDescription(data) {
	}

	toggleCheck(index, isChecked) {
		const newArray = this.state.checkedArray;
		newArray[index] = !isChecked;
		this.setState({ checkedArray: newArray });
	}

    render() {
 		const { id, slug, data, className, isMobile, fullUrl=null, isAffiliate, seo, settings={} } = this.props;
 		if (!isValid(data)) { return null; }
 		let { byline={}, servings } = data;
        let { prep, cook, total } = byline;
        let { selectedDirection } = this.state;
        const hideRecipeRatings = settings.hideRecipeRatings == 1;
        let directionsArray = this.makeArray(data.directions);
        let ingredientsArray = this.makeArray(data.ingredients);
        let nutritionArray = this.makeArray(data.nutrition);

        const renderedIngredientList = ingredientsArray.map((ingredient, i) => (
	        <RecipeIngredient
	            data={ingredient}
	            key={i}
	            isMobile={isMobile}
	            index={i}
	            isChecked={this.state.checkedArray[i]}
	            toggleCheck={this.toggleCheck}
	         />
    	));

		const renderedDirections = directionsArray.map((direction, i) => {
			let className = "recipe-direction";
				className = (selectedDirection === i) ? "recipe-direction selected" : "recipe-direction";
			return (
					<div className={className} onClick={() => this.setState({selectedDirection: i})} dangerouslySetInnerHTML={ { __html: direction } } />
			)
		});

		const renderedNutrition = nutritionArray.map((nutrient, i) => {
			const freeformBtnTag = '<div class="wp-block-button standard">';
			const affiliateBtnTag = '<div class="affiliate-btn">';
			const hasFreeformBtn = (nutrient.includes(freeformBtnTag) || nutrient.includes(affiliateBtnTag));
			if (!hasFreeformBtn) {
				return (
					<li className="nutrient" dangerouslySetInnerHTML={ { __html: nutrient} } />
				)
			}
		});

	    return (
	      	<div className="recipe">
	      		<div id="recipe-jump"className="recipe-time-byline">
					<div className="recipe-time-byline-top">
						<div className="prep"><span>Prep</span></div>
						<div className="cook"><span>Cook</span></div>
						<div className="total"><span>Total</span></div>
						<div className="serves"><span>Serves</span></div>
					</div>
					<div className="recipe-time-byline-hr"></div>
					<div className="recipe-time-byline-bottom">
						<div className="prep"><span dangerouslySetInnerHTML={ { __html: prep } }></span></div>
						<div className="cook"><span dangerouslySetInnerHTML={ { __html: cook } }></span></div>
						<div className="total"><span dangerouslySetInnerHTML={ { __html: total } }></span></div>
						<div className="serves"><span dangerouslySetInnerHTML={ { __html: servings } }></span></div>
					</div>
				</div>
				<h2>Ingredients</h2>
				<div className="ingredients recipe-list" id="ingredients-list">
				{renderedIngredientList}
				<div className="chicory-order-ingredients" onClick={() => segmentTrackEvent('chicory', {label: `ingredients_button_${name}`, action: 'click'})}></div>
				</div>
				<h2>Directions</h2>
				<div className="directions recipe-list">
					{renderedDirections}
				</div>
				{ ((isValid(data.nutrition)) && (data.nutrition !== "\n&lt;p&gt;&lt;/p&gt;\n")) &&
					<Fragment>
						<div className="nutrition recipe-list">
							<span>Nutrition Facts</span>
							<ul>{renderedNutrition}</ul>
						</div>
						<div className="edamam-nutrition">
						<p>Powered By </p>
							<a href="https://www.edamam.com/" target="_blank"><img src="https://www.purewow.com/static-gmg/purewow/logos/edamam_logo_full.svg"/></a>
						<p className="edamam-fineprint">Note: The information shown is Edamam's estimate based on available ingredients and preparation. It should not be considered a substitute for a professional nutritionist's advice.</p>
						</div>
					</Fragment>
				}
				{!hideRecipeRatings && <RecipeRatings id={id} slug={slug} isMobile={isMobile} />}
			</div>
	    );
    }
}

RecipeBasic.propTypes = {
  className: PropTypes.string,
};

export default RecipeBasic;